<template>
  <div>
    <div id="menuOrder"><!-- menu-log -->
      <div class="container menu-order">
        <div class="container">
          <h3 class="title-order">
            Zamawianie zestawu pobraniowego
          </h3>
        </div>
        <breadcrumb-collection-set :active_page="active_page"></breadcrumb-collection-set>
      </div>
    </div>

    <!-- order-set -->
    <section class="order-set" v-if="isPageActive(1)">
      <div class="container">
        <div class="col-12">
          <div class="row align-items-center">
            <div class="col-3 img">
              <img src="../assets/img/collection-sets-square.png" alt="" class="">
            </div>
            <div class="col-5 descrition">
              <h2 class="title">{{collection_set[localize('name')]}}</h2>
              <p class="text">Lorem ipsum dolor sit amet,
                consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore
                et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.</p>
            </div>

            <div class="separator"></div>

            <div class="col-2 amount">
              <h3 class="text-center">Amount</h3>

              <div class="qty align-items-right">
                <div class="row">
                  <span class="minus"><img src="../assets/img/minus-q.png" alt="" @click="deleteSet"></span>
                  <input type="number" class="count" name="qty" value="1" disabled="disabled"
                         v-model="order.collection_set_count"
                         @change="validateCollectionSetCount" id="collection_set_count"/>
                  <span class="plus"><img src="../assets/img/plus-q.png" alt="" @click="addSet"></span>
                </div>
              </div>
            </div>
            <div class="col-2 price text-right">
              <h3>{{$t('collection_set_order.price')}}</h3>
              <h2>{{this.priceTotal}} PLN</h2>
            </div>
          </div>
        </div>
        <div class="row text-center buttons">
          <div class="col">
            <a href="#" class="btn btn-main" @click="confirmOrderAmount" id="step_one">{{$t('collection_set_order.continue_button_label')}}</a>
          </div>
        </div>
      </div>
    </section>

    <!-- order-ship -->
    <section class="order-ship" v-if="isPageActive(2)">
      <div class="container">
        <div class="col-12">
          <h2 class="title">Shipment data</h2>
          <p class="text">Lorem ipsum dolor sit amet, consectetur
            adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
            magna aliqua. Ut enim ad minim veniam, quis nostrud. </p>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="col-lg-3 col-md-12">
              <h4 class="items">{{$t('collection_set_order.select_delivery_method')}}:</h4>
              <div class="form-check">
                <input class="form-check-input css-checkbox" type="radio" name="delivery_type" id="delivery_courier"
                       value="option1" v-model="order.delivery_type" v-bind:value="delivery_types[0]">
                <label class="form-check-label css-label text" for="delivery_courier">
                  {{$t(delivery_types[0].title)}}
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input  css-checkbox" type="radio" name="delivery_type" id="delivery_inperson"
                       v-model="order.delivery_type" v-bind:value="delivery_types[1]">
                <label class="form-check-label css-label text" for="delivery_inperson">
                  {{$t(delivery_types[1].title)}}
                </label>
              </div>
            </div>

            <div class="col-lg-7 col-md-12 offset-1">
              <h4 class="items">Dane dostawy</h4>

              <form action="reg-3" class="main-form needs-validation-delivery" novalidate=""
                    v-if="showDeliveryAdressForm">
                <div class="col">
                  <div class="form-group row">
                    <label for="name" class="col-sm-4 col-form-label">{{$t('collection_set_order.name')}}</label>
                    <div class="col-md-12">
                      <input type="text" name="name" id="name" class="form-control" required=""
                             v-model="order.delivery_name"/>
                      <div class="invalid-feedback">Required!</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="surname" class="col-sm-4 col-form-label">{{$t('collection_set_order.surname')}}</label>
                    <div class="col-md-12">
                      <input type="text" name="surname" id="surname" class="form-control" required=""
                             v-model="order.delivery_surname"/>
                      <div class="invalid-feedback">Required!</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="street" class="col-sm-4 col-form-label">{{$t('collection_set_order.street_no')}}</label>
                    <div class="col-md-12">
                      <input type="text" name="street" id="street" class="form-control" required=""
                             v-model="order.delivery_street"/>
                      <div class="invalid-feedback">Required!</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="post_code"
                           class="col-sm-4 col-form-label">{{$t('collection_set_order.postal_code')}}</label>
                    <div class="col-md-12">
                      <input type="text" name="post_code" id="post_code" class="form-control" required=""
                             v-model="order.delivery_post_code"/>
                      <div class="invalid-feedback">Required!</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="city" class="col-sm-4 col-form-label">{{$t('collection_set_order.city')}}</label>
                    <div class="col-md-12">
                      <input type="text" name="city" id="city" class="form-control" required=""
                             v-model="order.delivery_city"/>
                      <div class="invalid-feedback">Required!</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="phone" class="col-sm-4 col-form-label">{{$t('collection_set_order.phone')}}</label>
                    <div class="col-md-12">
                      <input type="text" name="phone" id="phone" class="form-control" required=""
                             v-model="order.delivery_phone"/>
                      <div class="invalid-feedback">Required!</div>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="row text-center buttons">
          <div class="col">
            <a href="#" class="btn btn-main" @click="gotoPage(1)">{{$t('collection_set_order.back_button_label')}}</a>
            <a href="#" class="btn btn-main" @click="confirmDelivery">{{$t('collection_set_order.continue_button_label')}}</a>
          </div>
        </div>
      </div>
    </section>

    <!-- summary -->
    <section class="summary" v-if="isPageActive(3)">
      <div class="container">
        <div class="col-12">
          <h2 class="title">{{$t('collection_set_order.summary')}}</h2>
          <p class="text">Lorem ipsum dolor sit amet, consectetur
            adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
            magna aliqua. Ut enim ad minim veniam, quis nostrud. </p>
        </div>

        <div class="col-md-6">
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <h4 class="items">Items:</h4>
              <div class="row col">
                <h5 class="text">{{collection_set[localize('name')]}}</h5>
                <h5 class="sets-items">x{{order.collection_set_count}}</h5>
              </div>
              <div class="row col price">
                <h4 class="price-tetx">{{$t('collection_set_order.total')}}:</h4>
                <h4 class="amount">{{this.priceTotal}}</h4>
                <h4 class="currency">,- PLN</h4>
              </div>
            </div>

            <div class="col-lg-5 col-md-12 offset-1">
              <h4 class="items">{{$t('collection_set_order.shipment_label')}}:</h4>
              <div class="row col">
                <h5 class="delivery-method text">{{$t(order.delivery_type.title)}}</h5>
              </div>
            </div>
          </div>
        </div>

        <div class="row text-center buttons">
          <div class="col">
            <a href="#" class="btn btn-main" @click="gotoPage(2)">{{$t('collection_set_order.change_button_label')}}</a>
            <a href="#" class="btn btn-main"
               @click="confirmAndPay">{{$t('collection_set_order.order_button_label')}}</a>
          </div>
        </div>
      </div>
    </section>

    <!-- order-payment -->
    <section class="order-payment" v-if="isPageActive(4)">
      <div class="container">
        <div class="col-12">
          <h2 class="title">Payment</h2>
          <p class="text">Lorem ipsum dolor sit amet, consectetur
            adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
            magna aliqua. Ut enim ad minim veniam, quis nostrud. </p>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="col-lg-3 col-md-12">
              <h4 class="items">Choose method:</h4>
              <div class="form-check">
                <input class="form-check-input  css-checkbox" type="radio" name="payment_method" id="bank_transfer"
                       v-model="order.payment_method" v-bind:value="payment_methods[0]" checked="checked">
                <label class="form-check-label  css-label text" for="bank_transfer">
                  {{$t(payment_methods[0].title)}}
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input css-checkbox" type="radio" name="payment_method" id="online_transfer"
                       v-model="order.payment_method" v-bind:value="payment_methods[1]"/>
                <label class="form-check-label css-label text" for="online_transfer">
                  {{$t(payment_methods[1].title)}}
                </label>
              </div>

            </div>

            <div class="col-lg-7 col-md-12 offset-1" v-if="this.order.payment_method.id == 1">
              <h4 class="items">Payment details</h4>
              <div class="details">
                <h5 class="address-details text">Reciever: <b>GENOMED S.A.</b> - ul. Ponczowa 12, 02-971 Warszawa</h5>
                <h5 class="bank-details text">Bank account: 1234 4567 7890 0000 00001</h5>
                <h5 class="iban-details text">IBAN: PL0135484684321</h5>
                <h5 class="transfer-details text">Transfer title: Order #{{order_number}}</h5>
              </div>
            </div>

            <div class="col-lg-7 col-md-12 offset-1" v-if="this.order.payment_method.id == 2">
              <h4 class="items">Dotpay</h4>
            </div>
          </div>
        </div>

        <div class="row text-center buttons">
          <div class="col">
            <a href="#" class="btn btn-main" v-if="this.order.payment_method.id == 1" @click="gotoPage(5)">Continue</a>
            <form action="https://ssl.dotpay.pl/test_payment/" method="POST" v-if="this.order.payment_method.id == 2">
              <input type="hidden" name='id' id="id" :value="shop_id"/>
              <input type="hidden" name='amount' id="amount" :value="priceTotal"/>
              <input type="hidden" name="currency" id="currency" value="PLN"/>
              <input type="hidden" name="chk" id="chk" :value="payment_checksum"/>
              <input type="hidden" name="description" id="description" :value="order_number"/>
              <input type="hidden" name="url" id="url" value="http://localhost:8000/#/payment/success"/>
              <input type="hidden" name="type" id="type" value="0"/>
              <button id="pay_button" type="submit" class="btn btn-main">
                {{$t('collection_set_order.pay_button_label')}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- order-confirmation -->
    <section class="order-confirmation" v-if="isPageActive(5)">
      <div class="container">
        <div class="row text-center success">
          <div class="col">
            <img src="../assets/img/success-icon.png" alt="">
          </div>
        </div>
        <div class="col-8 offset-2 col-box">
          <h2 class="title">Your order was placed successfully.</h2>
          <p class="text">Lorem ipsum dolor sit amet, consectetur
            adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
            magna aliqua. Ut enim ad minim veniam, quis nostrud.</p>
        </div>

        <div class="row text-center buttons">
          <div class="col">
            <router-link :to="{name:'home-view'}" class="btn btn-main">Wróć do strony głównej</router-link>
          </div>
        </div>
      </div>

    </section>
  </div>

</template>

<script>
  import BreadcrumbCollectionSet from "../components/BreadcrumbCollectionSet";
  import {FETCH_COLLECTION_SET, DISPLAY_MESSAGE, ORDER_COLLECTION_SET} from "../store/actions";
  import {mapGetters} from 'vuex';
  import translatorMixin from '../mixins/translatorMixin';

  export default {
    name: "SingleSetOrder",
    components: {BreadcrumbCollectionSet},
    mixins: [translatorMixin],
    data: function () {
      return {
        active_page: 1,
        delivery_types: [
          {id: 1, title: "collection_set_order.delivery_types.courier"},
          {id: 2, title: "collection_set_order.delivery_types.collect_in_person"}
        ],
        payment_methods: [
          {id: 1, title: "collection_set_order.payment_methods.bank_transfer"},
          {id: 2, title: "collection_set_order.payment_methods.online_transfer"}
        ],
        order: {
          collection_set_id: 1, // TODO magic number
          collection_set_count: 1,
          delivery_type: [],
          payment_method: [],
          delivery_name: '',
          delivery_surname: '',
          delivery_street: '',
          delivery_city: '',
          delivery_post_code: '',
          delivery_phone: ''
        }
      }
    },
    mounted: function () {
      this.$store.dispatch(FETCH_COLLECTION_SET);
      this.order.delivery_type = this.delivery_types[0];
      this.order.payment_method = this.payment_methods[0];
    },
    computed: {
      ...mapGetters(['collection_set', 'shop_id', 'payment_checksum', 'order_number']),
      priceTotal: function () {
        if (this.order.collection_set_count > 0) {
          let price = this.order.collection_set_count * this.collection_set.price;
          return price.toFixed(2).toString();
        } else {
          return 0;
        }
      },
      showDeliveryAdressForm: function () {
        return this.order.delivery_type == this.delivery_types[0];
      }
    },
    methods: {
      validateCollectionSetCount: function () {
        if ((this.order.collection_set_count <= 0) && (!Number.isInteger(this.order.collection_set_count))) {
          this.order.collection_set_count = 1;
        }
      },
      isPageActive: function (page) {
        return this.active_page == page;
      },
      gotoPage: function (page) {
        this.active_page = page;
      },
      confirmOrderAmount: function () {
        this.gotoPage(2);
      },
      confirmDelivery: function () {
        if (this.order.delivery_type == this.delivery_types[0]) {
          if (!this.order.delivery_name || !this.order.delivery_surname || !this.order.delivery_street || !this.order.delivery_city || !this.order.delivery_phone) {
            this.$store.dispatch(DISPLAY_MESSAGE, {
              message: {
                type: 'danger',
                content: this.$t('collection_set_order.alerts.please_provide_shipment_address')
              }
            })
            return false;
          }
        }

        this.gotoPage(3);
      },
      confirmAndPay: function () {
        this.$store.dispatch(ORDER_COLLECTION_SET, this.order)
        this.gotoPage(4);
      },
      pay: function () {
        alert("pay")
      },
      addSet: function () {
        this.order.collection_set_count += 1;
      },
      deleteSet: function () {
        if (this.order.collection_set_count > 1) {
          this.order.collection_set_count -= 1;
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/CollectionSetOrder.vue